'use strict'

module.exports = { version: '8.15.0' }
